import { createRouter, createWebHashHistory } from 'vue-router'
import NotFound from '@/views/NotFound.vue';

// function getParams() {
//   let item = sessionStorage.getItem('params');
//   return item ? JSON.parse(item) : [];
// }
//
// function setParam(key, value) {
//   let params = getParams();
//   params = params.filter(p => p.key !== key);
//   params.push({ key, value });
//   sessionStorage.setItem('params', JSON.stringify(params));
// }
//
const routes = [
  {
    path: '/',
    redirect: '/signin',
  },
  {
    path: '/signin',
    name: 'signin',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "start" */ '@/views/home/Home.vue'),
  },
  {
    path: '/help/:id',
    name: 'help',
    component: () => import(/* webpackChunkName: "start" */ '@/views/help/Help.vue'),
  },
  {
    path: '/support',
    name: 'support',
    component: () => import(/* webpackChunkName: "start" */ '@/views/support/Support.vue'),
  },
  {
    path: '/accept/account/:invitationId',
    name: 'acceptAccount',
    redirect: to => {
      return { name: 'signin' };
    }
  },
  {
    path: '/accept/user/:invitationId',
    name: 'acceptUser',
    redirect: to => {
      console.log('START ROUTER');
      // setParam('pros-process', 'AcceptInvite');
      // setParam('pros-invitationId', to.params.invitationId);
      // let query = {
      //   'pros-process': 'AcceptInvite',
      //   'pros-invitationId': to.params.invitationId
      // };
      // return { name: 'signin', query };
      return { name: 'signin' };
    }
  },
  {
    path: '/accept/code/:oc',
    name: 'acceptCode',
    redirect: to => {
      return { name: 'signin' };
    }
  },
  {
    path: '/activate/lf',
    name: 'lfCode',
    redirect: to => {
      return { name: 'signin' };
    }
  },
  {
    path: '/activate/lf/:sc',
    name: 'lfAddDevice',
    redirect: to => {
      return { name: 'signin' };
    }
  },
  {
    path: '/unsubscribe',
    name: 'unsubscribe',
    redirect: to => {
      return { name: 'signin' };
    }
  },
  {
    path: '/redirect',
    name: 'redirect',
    redirect: to => {
      return { name: 'signin' };
    }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: NotFound,
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes
});

router.beforeEach((to, from, next) => {
  if (to.name === 'help') {
    window.$printos.header.v1.hideHeader();
  }
  else {
    window.$printos.header.v1.showHeader();
  }
  next();
})
export default router
